import { Link } from "react-router-dom";

import logo from "@/assets/logo/promptlayer-cake-color.svg";
import { Button } from "@/components/ui/button";

import {
  MOBILE_SCHEDULE_DEMO_BUTTON_TEXT,
  MOBILE_WARNING_MESSAGE,
} from "./constants";
import useIsMobile from "@/hooks/useIsMobile";
import { useEffect } from "react";
import { useState } from "react";
import { DialogContent, Dialog } from "@/components/ui/dialog";
import { DialogClose } from "@radix-ui/react-dialog";

export const NoMobileSupportMessage = () => {
  const shouldShowCalendly = localStorage.getItem("showScheduleCallModal");
  const shouldShowMessage = localStorage.getItem("showMobileMessage");
  const isMobile = useIsMobile();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (shouldShowMessage === "false") {
      return;
    }

    if (isMobile && !isOpen) {
      setIsOpen(true);
    }

    if (!isMobile && isOpen) {
      setIsOpen(false);
    }
  }, [isMobile, isOpen, shouldShowMessage]);

  const handleClose = (value: boolean) => {
    if (!value) {
      localStorage.setItem("showMobileMessage", "false");
    }

    setIsOpen(value);
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent
        className="m-0 h-screen w-screen max-w-none rounded-none border-0 p-0"
        shouldShowCloseButton={false}
      >
        <div className="relative inset-0 flex h-screen w-screen flex-col items-center justify-center gap-4 bg-white">
          <img src={logo} alt="PromptLayer logo" className="h-14 w-14" />
          <p className="text-lg font-bold">
            We don't support mobile devices yet.
          </p>
          <p className="text-center text-sm text-gray-500">
            {shouldShowCalendly
              ? MOBILE_SCHEDULE_DEMO_BUTTON_TEXT
              : MOBILE_WARNING_MESSAGE}
          </p>
          {shouldShowCalendly && (
            <div className="flex flex-col gap-2">
              <Button variant="outline">
                <Link to="https://calendly.com/d/crwt-mj8-nnc/promptlayer-demo-with-david-and-jon">
                  Schedule a demo
                </Link>
              </Button>
            </div>
          )}
          <DialogClose asChild>
            <Button variant="outline">Close</Button>
          </DialogClose>
        </div>
      </DialogContent>
    </Dialog>
  );
};
